export default {
  clientId ({ clientId }) {
    return clientId
  },
  GET_SHOW_HOME_BOTTOM_BAR (state) {
    return state.showHomeBottomBar
  }
}
